import * as ng from 'angular';
import {identity} from 'lodash-es';
import AppConstants from '../gorillaboy/AppConstants';

import './components/recentViews';
import './components/recentShares';
import './components/assignedTasks';
import Features from "../feature-manager/Features";

function tasksConfigFunction($routeProvider) {
    const TEMPLATE_LAYOUT = './assets/partials/app/layout.html';

    function resolveUserInfo () {
        return ['AuthService', '$location', '$q', '$log', function (authService, $location: ng.ILocationService, $q : ng.IQService, $log: ng.ILogService) {
            return authService.getUserInfo(false).then(null, function(error) {
                $log.error("Encountered error while fetching userInfo inside resolveUserInfo of dboardContoller module.ts");
                $location.url('/genericError');
                return $q.reject(error);
            });
        }];
    }

    $routeProvider
    .when('/dboard', {
        auth: true,
        templateUrl: TEMPLATE_LAYOUT,
        controller: 'dboardController',
        resolve: {
            userInfo: resolveUserInfo(),                    
            View: identity.bind(null, AppConstants.ViewTypes.DBOARD_TYPE),
            featureMap: ['FeatureManagerService', '$location', '$q', '$log', function(FeatureManagerService: any, $location: ng.ILocationService, $q : ng.IQService, $log: ng.ILogService) {
                return FeatureManagerService.getEnabledFeatureMap().then((data) => {
                    if (!FeatureManagerService.isFeatureEnabled(Features.UI.DASHBOARD_HOME)) {
                        //If the feature is not enabled redirect to /mydocs
                        $location.url('/mydocs');
                        return $q.reject(false);
                    }
                    return data;
                }, function(error) {
                    $log.error("Encountered error while fetching enabledFeatureMap inside featureManagerService of taskContoller module.ts");
                    $location.url('/genericError');
                    return $q.reject(error);
                });
            }]
        }
    });
};

tasksConfigFunction.$inject = ['$routeProvider'];
angular.module('GorillaBoy.Dboard')
.config(tasksConfigFunction);
